import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  hr: {
    translation: {
      // Header
      nav: {
        home: 'Početna',
        services: 'Usluge',
        about: 'O nama',
        contact: 'Kontakt'
      },
      // Hero
      hero: {
        title: 'Digitalna rješenja',
        subtitle: 'za moderne tvrtke',
        description: 'Stvaramo vrhunski softver i upravljamo infrastrukturom koja pokreće vaš uspjeh.',
        cta: 'Započnimo projekt',
        learnMore: 'Saznajte više',
        stats: {
          years: 'Godina iskustva',
          projects: 'Uspješnih projekata',
          support: 'Podrška'
        }
      },
      // Services
      services: {
        title: 'Što radimo',
        webDev: {
          title: 'Web Development',
          desc: 'Moderne web aplikacije optimizirane za performanse i korisničko iskustvo.'
        },
        customSoft: {
          title: 'Custom Software',
          desc: 'Prilagođena poslovna rješenja koja rješavaju vaše specifične izazove.'
        },
        cloud: {
          title: 'Cloud & Infrastructure',
          desc: 'Skalabilna cloud arhitektura i profesionalno upravljanje poslužiteljima.'
        },
        consulting: {
          title: 'Tech Consulting',
          desc: 'Strateški savjeti za digitalizaciju i tehnološku transformaciju.'
        }
      },
      // About
      about: {
        title: 'Tehnologije',
        intro: 'Specijalizirani smo za backend development, cloud infrastrukturu i moderne web aplikacije.',
        description: 'Svaki projekt je različit. Odabiremo tehnologije prema potrebama klijenta - od manjih web stranica do složenih poslovnih aplikacija.',
        tech: {
          backend: 'Backend',
          backendList: 'Laravel (PHP) · Django (Python)',
          frontend: 'Frontend',
          frontendList: 'React · Vue.js · Tailwind CSS · Custom CSS',
          cms: 'CMS',
          cmsList: 'WordPress · Filament',
          cloud: 'Cloud & DevOps',
          cloudList: 'Google Cloud · Cloud Functions · Server Management'
        }
      },
      // Contact
      contact: {
        title: 'Kontaktirajte nas',
        subtitle: 'Razgovarajmo o vašem projektu',
        form: {
          name: 'Ime i prezime',
          email: 'Email adresa',
          phone: 'Telefon',
          company: 'Tvrtka',
          message: 'Vaša poruka',
          send: 'Pošalji poruku',
          sending: 'Šaljem...'
        },
        info: {
          title: 'Kontakt informacije',
          address: 'Adresa',
          addressValue: 'Medovićeva 3, 51000 Rijeka',
          email: 'Email',
          emailValue: 'info@loga.hr',
          phone: 'Mobitel',
          phoneValue: '+385 91 979 6179'
        },
        success: 'Hvala! Vaša poruka je uspješno poslana. Javit ćemo vam se uskoro.',
        error: 'Došlo je do greške. Molimo pokušajte ponovno ili nas kontaktirajte direktno.'
      },
      // Footer
      footer: {
        description: 'obrt za računalno programiranje',
        quickLinks: 'Brze poveznice',
        services: 'Usluge',
        contact: 'Kontakt',
        rights: 'Sva prava pridržana.',
        privacy: 'Privatnost',
        terms: 'Uvjeti korištenja',
        social: 'Pratite nas'
      }
    }
  },
  en: {
    translation: {
      // Header
      nav: {
        home: 'Home',
        services: 'Services',
        about: 'About',
        contact: 'Contact'
      },
      // Hero
      hero: {
        title: 'Digital solutions',
        subtitle: 'for modern companies',
        description: 'We create premium software and manage the infrastructure that powers your success.',
        cta: 'Start a project',
        learnMore: 'Learn more',
        stats: {
          years: 'Years Experience',
          projects: 'Projects Delivered',
          support: 'Support'
        }
      },
      // Services
      services: {
        title: 'What we do',
        webDev: {
          title: 'Web Development',
          desc: 'Modern web applications optimized for performance and user experience.'
        },
        customSoft: {
          title: 'Custom Software',
          desc: 'Tailored business solutions that address your specific challenges.'
        },
        cloud: {
          title: 'Cloud & Infrastructure',
          desc: 'Scalable cloud architecture and professional server management.'
        },
        consulting: {
          title: 'Tech Consulting',
          desc: 'Strategic advice for digitalization and technological transformation.'
        }
      },
      // About
      about: {
        title: 'Technologies',
        intro: 'Specialized in backend development, cloud infrastructure and modern web applications.',
        description: 'Every project is different. We choose technologies based on client needs - from simple websites to complex business applications.',
        tech: {
          backend: 'Backend',
          backendList: 'Laravel (PHP) · Django (Python)',
          frontend: 'Frontend',
          frontendList: 'React · Vue.js · Tailwind CSS · Custom CSS',
          cms: 'CMS',
          cmsList: 'WordPress · Filament',
          cloud: 'Cloud & DevOps',
          cloudList: 'Google Cloud · Cloud Functions · Server Management'
        }
      },
      // Contact
      contact: {
        title: 'Get in touch',
        subtitle: 'Let\'s talk about your project',
        form: {
          name: 'Full name',
          email: 'Email address',
          phone: 'Phone',
          company: 'Company',
          message: 'Your message',
          send: 'Send message',
          sending: 'Sending...'
        },
        info: {
          title: 'Contact information',
          address: 'Address',
          addressValue: 'Medovićeva 3, 51000 Rijeka, Croatia',
          email: 'Email',
          emailValue: 'info@loga.hr',
          phone: 'Mobile',
          phoneValue: '+385 91 979 6179'
        },
        success: 'Thank you! Your message has been sent successfully. We\'ll get back to you soon.',
        error: 'An error occurred. Please try again or contact us directly.'
      },
      // Footer
      footer: {
        description: 'Computer Programming Business',
        quickLinks: 'Quick links',
        services: 'Services',
        contact: 'Contact',
        rights: 'All rights reserved.',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
        social: 'Follow us'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'hr', // Default language
    fallbackLng: 'hr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;